export enum Permissions {
  REFUND = "REFUND",
  PAYOUT = "PAYOUT",
  DISCOUNT = "DISCOUNT",
  CASH_CHANGE = "CASH_CHANGE",
  INVOICE = "INVOICE",
  CREDIT_NOTE = "SELL_CREDIT_NOTE",
  GIFT_CARD = "SELL_GIFT_CARD",
  INTER_STORE_DEBT = "INTER_STORE_DEBT",
  DELETE_TAB = "DELETE_TAB",
  END_OF_DAY_REPORT = "END_OF_DAY_REPORT",
  PERIOD_REPORT = "PERIOD_REPORT",
  STATISTICS = "STATISTICS",
  PRODUCT_MANAGEMENT = "PRODUCT_MANAGEMENT",
  CHAIN_CATALOG = "CHAIN_CATALOG",
  MANAGE_OFFERS = "MANAGE_OFFERS",
  BOOKKEEPING_VOUCHERS = "BOOKKEEPING_VOUCHERS",
  STORE_SETTINGS = "STORE_SETTINGS",
  PAYMENT_METHOD_MANAGEMENT = "PAYMENT_METHOD_MANAGEMENT",
  DEVICE_CONFIGURATION = "DEVICE_CONFIGURATION",
  PRINTERS_MANAGEMENT = "PRINTERS_MANAGEMENT",
  RESTAURANT_SETUP = "RESTAURANT_SETUP",
  MANAGE_LAYOUTS = "MANAGE_LAYOUTS",
  MANAGE_FLOOR_PLANS = "MANAGE_FLOOR_PLANS",
  MANAGE_PRODUCT_PAGES = "MANAGE_PRODUCT_PAGES",
  MANAGE_ONLINE_ORDERS = "MANAGE_ONLINE_ORDERS",
  MANAGE_ORDERS = "MANAGE_ORDERS",
  STAFF_MANAGEMENT = "STAFF_MANAGEMENT",
  PERMISSION_GROUP_MANAGEMENT = "PERMISSION_GROUP_MANAGEMENT",
  ACCESS_MENU = "ACCESS_MENU",
  STOCK_LOCATIONS = "STOCK_LOCATIONS",
  STOCK_POLICIES = "STOCK_POLICIES",
  MANAGE_API_CLIENTS = "MANAGE_API_CLIENTS",
}

export const ALL_PERMISSIONS = Object.values(Permissions);
